<template>
<div :id="wrapperId" :class="cssClass" class="position-relative d-flex">
    <f-set v-if="canSelectType" cssClass="w-125-px pr-2" :value="value.type" @input="updateValue($event,'type')" :data="c_fields.type"/>
    <f-set :cssClass="numberCssClass" :value="value.number" @input="updateValue($event,'number')" :data="c_fields.number"/>
    <f-set v-if="!hideExt" cssClass="w-75-px pr-2 pt-25" :value="value.ext" @input="updateValue($event,'ext')" :data="c_fields.ext"/>
</div>
    
</template>

<script>
import Vue from 'vue'
import fieldBuilder from '@/mixins/fieldBuilder'

export default {
    mixins: [fieldBuilder],
    props: ['value','label','fields','phoneType' ,'cssClass','hideExt'],
    data() {
        return {
            wrapperId: 'phone-' + new Date().getTime(),
            d_fields: {
                type: this.makeField({ name: 'type', label: this.label ? this.label : 'Phone', type: 'select', options: { 'mobile': 'Mobile', 'home': 'Home', 'work': 'Work' } }),
                number: this.makeField({ name: 'number', mask: 'tel', label: (typeof(this.phoneType) == 'undefined' || this.phoneType.length == 0 )? false : this.label ? this.label : 'Phone' }),
                ext: this.makeField({ name: 'ext', label: false })
            },
            d_values: {
                hash: this.value.hash,
                type: this.value.type,
                number: this.value.number,
                ext: this.value.ext
            }

        }
    },
    computed: {
        canSelectType() {
            return typeof(this.phoneType) == 'undefined' || this.phoneType.length == 0;
        },
        numberCssClass() {
            return 'flex-grow-1 pr-2 ' + (this.canSelectType ? 'pt-25' : '');
        },
        c_fields() {
            return typeof(this.fields) !== 'undefined' ? this.fields : this.d_fields;
        }
    },
    methods: {
        updateValue(val, field) {
            if (field == 'number' && val && !this.d_values.number && this.canSelectType && !this.d_values.type) {
                //setting up default type on typing a blank number
                this.d_values.type = 'mobile';
            }
            this.d_values[field] = val;
            this.$emit('input', this.d_values)
        }
    },
    mounted() {
        this.d_values.type = this.canSelectType ? this.d_values.type : this.phoneType
        this.$emit('input', this.d_values) // this line is so not empty string is returned, but at least an object
    }
}
</script>